import { ShareDataService } from '../share-data/share-data.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../storage/storage.service';
import { MobileModeService } from './mobilemode.service';

@Injectable()
export class MobileModeGuardService implements CanActivate {
  static EVENT = {
    LOGIN_REQUIRED: 'LOGIN_REQUIRED',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGIN_TOKEN_EXPIRE: 'LOGIN_TOKEN_EXPIRE',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  }
  constructor(
    public mobileModeService: MobileModeService,
    public router: Router,
    public storage: StorageService,
  ){}
  async canActivate(activatedRouteSnapshot : ActivatedRouteSnapshot) {
    // console.log('isMobileMode activatedRouteSnapshot:', activatedRouteSnapshot.paramMap);
    if(activatedRouteSnapshot.paramMap){
      let userTokenFromMobile = activatedRouteSnapshot.paramMap.get('userToken')
      // console.log('isMobileMode userTokenFromMobile:', userTokenFromMobile);     
      let isMobile = await this.mobileModeService.isMobileMode(userTokenFromMobile);
      if (isMobile) {
        this.router.navigate(['children']);
        return false;
      }
    }
    return true;
  }

}
